
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec63f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec63f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lD3YP", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $fbf053db7c3cbea5$export$6503ec6e8aabbaf; }, function (v) { return $fbf053db7c3cbea5$export$6503ec6e8aabbaf = v; });
var $fbf053db7c3cbea5$export$6503ec6e8aabbaf;
var $fbf053db7c3cbea5$export$f7ad0328861e2f03;
"use strict";
var $fbf053db7c3cbea5$var$mapping = new Map();
function $fbf053db7c3cbea5$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$fbf053db7c3cbea5$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $fbf053db7c3cbea5$var$resolve(id) {
    var resolved = $fbf053db7c3cbea5$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$fbf053db7c3cbea5$export$6503ec6e8aabbaf = $fbf053db7c3cbea5$var$register;
$fbf053db7c3cbea5$export$f7ad0328861e2f03 = $fbf053db7c3cbea5$var$resolve;

});

var $f1b8974abd0a50e5$exports = {};

(parcelRequire("lD3YP")).register(new URL("", import.meta.url).toString(), JSON.parse('["dFxeQ","main.min.68af288d.js","46QKQ","../img/sprite.385b51e3.svg"]'));

const $5a52062d47bab30a$export$7d9f9b4046392aed = function() {
    return window.navigator.userAgentData?.mobile || window.matchMedia("(max-width: 768px)").matches;
};


// --------- NAVIGATION
// Elements
const $603f4f680d794e02$var$nav = document.querySelector('[data-js="nav"]');
const $603f4f680d794e02$var$mobileBtn = document.querySelector('[data-js="nav-mobile-btn"]');
const $603f4f680d794e02$var$navlist = document.querySelector('[data-js="nav-list"]');
const $603f4f680d794e02$var$navLinks = document.querySelectorAll('[data-js="nav-link"]');
// Elements outside of nav
const $603f4f680d794e02$var$header = document.querySelector('[data-js="header"]');
const $603f4f680d794e02$var$sections = document.querySelectorAll('[data-spy="section"]');
// -------------------------------------------------------------------
const $603f4f680d794e02$var$toggleMobileNav = function() {
    $603f4f680d794e02$var$mobileBtn.classList.toggle("is-active");
    $603f4f680d794e02$var$navlist.classList.toggle("active");
};
const $603f4f680d794e02$var$clickLinkHandle = function(e) {
    const isLink = e.target.hasAttribute("href");
    if (!isLink) return;
    $603f4f680d794e02$var$toggleMobileNav();
    $603f4f680d794e02$var$navlist.removeEventListener("click", $603f4f680d794e02$var$clickLinkHandle);
};
const $603f4f680d794e02$export$abbbf9220a944d5 = function() {
    $603f4f680d794e02$var$mobileBtn.addEventListener("click", (e)=>{
        $603f4f680d794e02$var$toggleMobileNav();
        $603f4f680d794e02$var$navlist.addEventListener("click", $603f4f680d794e02$var$clickLinkHandle);
        // A11Y
        const isExpanded = $603f4f680d794e02$var$mobileBtn.getAttribute("aria-expanded") === "false" ? "true" : "false";
        $603f4f680d794e02$var$mobileBtn.setAttribute("aria-expanded", isExpanded);
    });
};
const $603f4f680d794e02$export$1f3d3a9da2a0fa96 = function() {
    if ((0, $5a52062d47bab30a$export$7d9f9b4046392aed)()) return;
    const handleActiveSection = function(entries) {
        entries.forEach((entry)=>{
            const { isIntersecting: isIntersecting, target: target } = entry;
            const activeNav = document.querySelector(`a[href='#${target.id}']`);
            if (isIntersecting) {
                $603f4f680d794e02$var$navLinks.forEach((link)=>link.classList.remove("active"));
                activeNav.classList.add("active");
            }
            if (!isIntersecting) activeNav.classList.remove("active");
        });
    };
    const options = {
        rootMargin: "0px",
        threshold: [
            0.4,
            0.7,
            0.9
        ]
    };
    const spyObserver = new IntersectionObserver(handleActiveSection, options);
    $603f4f680d794e02$var$sections.forEach((section)=>spyObserver.observe(section));
};
const $603f4f680d794e02$export$6ea2a03303ca6765 = function() {
    if (window.window.innerWidth >= 2400) return;
    const handleBackground = function(entries) {
        const { isIntersecting: isIntersecting } = entries[0];
        if (!isIntersecting) $603f4f680d794e02$var$nav.classList.add("nav--bgc");
        if (isIntersecting) $603f4f680d794e02$var$nav.classList.remove("nav--bgc");
    };
    const options = {
        threshold: 0
    };
    const mainObserver = new IntersectionObserver(handleBackground, options);
    mainObserver.observe($603f4f680d794e02$var$header);
};



// ------------------------------------------------------------
// DOM ELEMENTS
const $f743f4b4e300ee64$var$header = document.querySelector('[data-js="header"]');
const $f743f4b4e300ee64$var$topHeader = document.querySelector('[data-js="header-heading-top"]');
const $f743f4b4e300ee64$var$bottomHeader = document.querySelector('[data-js="header-heading-bottom"]');
const $f743f4b4e300ee64$var$subHeading = document.querySelector('[data-js="header-subheading"]');
const $f743f4b4e300ee64$var$scroll = document.querySelector('[data-js="header-scroll"]');
const $f743f4b4e300ee64$var$photo = document.querySelector('[data-js="header-photo"]');
// ---------------------------------------------------------------
const $f743f4b4e300ee64$var$animationHandle = function() {
    const { bottom: bottom, height: height } = $f743f4b4e300ee64$var$header.getBoundingClientRect();
    const fromTopPosPerc = (1 - bottom / height) * 100;
    const photoOpacity = 10;
    /**
   * Calculate visibility, e.g. For passed parameters: (10, 20) => 50 , (5, 20) => 25
   * @param {number} actualPos - Percentage of actual position from top observed DOM object/container.
   * @param {number} endPointPos - Targeted position in percentage from top observed DOM object/container when returned value will be '100'.
   * @returns {number}
   */ const calcVisibility = function(actualPos, endPointPos) {
        return actualPos / endPointPos * 100;
    };
    const visibility = calcVisibility(fromTopPosPerc, 20);
    const scrollVisibility = 100 - calcVisibility(fromTopPosPerc, 50);
    $f743f4b4e300ee64$var$topHeader.style.transform = `translateY(-${visibility}%)`;
    $f743f4b4e300ee64$var$bottomHeader.style.transform = `translateY(${visibility}%)`;
    $f743f4b4e300ee64$var$subHeading.style.opacity = visibility === 0 ? "1" : "0";
    $f743f4b4e300ee64$var$photo.style.opacity = `${visibility < photoOpacity ? photoOpacity : visibility}%`;
    $f743f4b4e300ee64$var$photo.style.filter = `grayscale(${100 - visibility}%)`;
    $f743f4b4e300ee64$var$scroll.style.opacity = `${scrollVisibility}%`;
    $f743f4b4e300ee64$var$scroll.style.pointerEvents = scrollVisibility <= 0 ? "none" : "all";
};
const $f743f4b4e300ee64$var$observerOptions = {
    rootMargin: "0px",
    threshold: 0.3
};
const $f743f4b4e300ee64$export$5263a95d66ab56f4 = function() {
    if ((0, $5a52062d47bab30a$export$7d9f9b4046392aed)()) return;
    const controlAnimation = function(entries) {
        const { isIntersecting: isIntersecting } = entries[0];
        if (isIntersecting) window.addEventListener("scroll", $f743f4b4e300ee64$var$animationHandle);
        if (!isIntersecting) window.removeEventListener("scroll", $f743f4b4e300ee64$var$animationHandle);
    };
    const observer = new IntersectionObserver(controlAnimation, $f743f4b4e300ee64$var$observerOptions);
    observer.observe($f743f4b4e300ee64$var$header);
};



const $ebe1c8080cae0155$var$aboutmeSection = document.querySelector('[data-js="aboutme"]');
const $ebe1c8080cae0155$var$mottoEl = document.querySelector('[data-js="my-motto"]');
const $ebe1c8080cae0155$var$mottoElQuotes = document.querySelectorAll('[data-js="my-motto__quote"]');
const $ebe1c8080cae0155$var$animateTextTyping = function(element, textToType) {
    return new Promise((resolve, reject)=>{
        const textToAnimate = textToType || element.innerText;
        const time = 100;
        let i = 0;
        // Clear before typing animation
        element.innerHTML = "";
        const typeText = function(str) {
            i++;
            $ebe1c8080cae0155$var$mottoEl.textContent = str.slice(0, i);
            if (i === str.length) {
                clearInterval(animation);
                resolve();
            }
        };
        const animation = setInterval(()=>{
            typeText(textToAnimate);
        }, time);
    });
};
const $ebe1c8080cae0155$export$a586759acdda70cf = function() {
    if ((0, $5a52062d47bab30a$export$7d9f9b4046392aed)()) return;
    const textToType = $ebe1c8080cae0155$var$mottoEl.innerText;
    $ebe1c8080cae0155$var$mottoElQuotes.forEach((q)=>q.style.opacity = "0");
    $ebe1c8080cae0155$var$mottoEl.innerHTML = "";
    const controlAnimation = async function(entries) {
        const { isIntersecting: isIntersecting, target: target } = entries[0];
        if (isIntersecting) {
            observer.unobserve(target);
            $ebe1c8080cae0155$var$mottoEl.dataset.typeText = true;
            await $ebe1c8080cae0155$var$animateTextTyping($ebe1c8080cae0155$var$mottoEl, textToType);
            $ebe1c8080cae0155$var$mottoElQuotes.forEach((q)=>q.style.opacity = "1");
            $ebe1c8080cae0155$var$mottoEl.dataset.typeText = false;
        }
    };
    const options = {
        rootMargin: "0px",
        threshold: 0.5
    };
    const observer = new IntersectionObserver(controlAnimation, options);
    observer.observe($ebe1c8080cae0155$var$aboutmeSection);
};



const $da5314831e868781$var$imgs3D = document.querySelectorAll('[data-js="img3D"]');
const $da5314831e868781$var$rotate3dElement = function(e, target, maxDegrees, scale) {
    const rotateYposition = (e.layerX / target.scrollWidth * 2 - 1) * maxDegrees;
    const rotateXposition = (e.layerY / target.scrollHeight * 2 - 1) * maxDegrees;
    target.style.transform = `perspective(1200px) rotateX(${rotateXposition}deg) rotateY(${-rotateYposition}deg) scale3d(${scale}, ${scale}, ${scale})`;
};
const $da5314831e868781$export$d5c980a96d3b13bc = function() {
    if ((0, $5a52062d47bab30a$export$7d9f9b4046392aed)()) return;
    $da5314831e868781$var$imgs3D.forEach((img)=>{
        const screenCentralPoint = window.screen.width / 2;
        const isLeft = img.getBoundingClientRect().right < screenCentralPoint;
        const rotateY = isLeft ? "" : "-";
        img.addEventListener("mousemove", (e)=>{
            img.style.transition = "transform 100ms ease";
            $da5314831e868781$var$rotate3dElement(e, img, 10, 1.05);
        });
        img.addEventListener("mouseout", (e)=>{
            img.style.transition = "transform 300ms ease";
            img.style.transform = `perspective(1200px) rotateX(-2deg) rotateY(${rotateY}7deg) scale3d(1.05, 1.05, 1)`;
        });
    });
};


var $e1ce59189af85a62$exports = {};
$e1ce59189af85a62$exports = new URL("../img/sprite.385b51e3.svg", import.meta.url).toString();


// --------------------------------------------------------------
// DOM Elements
const $9ba15e4c4f7322f3$var$form = document.querySelector('[data-js="contact-form"]');
const $9ba15e4c4f7322f3$var$inputs = $9ba15e4c4f7322f3$var$form.querySelectorAll('[data-js="contact-form__input"]');
const $9ba15e4c4f7322f3$var$submitBtn = document.querySelector('[data-js="contact-form__submit-btn"]');
// -------------------------------------------------------------
const $9ba15e4c4f7322f3$var$emailURL = "/"; // "/" - url for netlify forms
const $9ba15e4c4f7322f3$var$ErrorMsg = {
    fullname: "The Full name should contain at least 3 characters.",
    email: "Please enter a correct email address.",
    message: "The message should contain at least 10 characters."
};
// --------------------------------------------------------------
// disable default html validation
$9ba15e4c4f7322f3$var$form.setAttribute("novalidate", true);
/**
 * Renders 'error' under the specified DOM Element with specified message.
 * @param {object} element - Input DOM Element
 * @param {string} msg - Text string to be displayed
 */ const $9ba15e4c4f7322f3$var$renderInputErrorMsg = function(element, msg) {
    const parent = element.closest(".form__row");
    const html = `                
    <p class="error-msg">
    ${msg}
     </p>`;
    parent.insertAdjacentHTML("beforeend", html);
};
/**
 * Remove error message under the specified DOM Element.
 * @param {object} element - Input DOM Element
 */ const $9ba15e4c4f7322f3$var$removeInputErrorMsg = function(element) {
    const parent = element.closest(".form__row");
    const errorMsg = parent.querySelector(".error-msg");
    if (errorMsg) errorMsg.remove();
};
// Adding or removing loading state from FORM depends on passed parameter
/**
 * Render or remove loading spinner depends on state
 * @param {boolean} addState - true = add loading spinner; false = remove loading spinner
 */ const $9ba15e4c4f7322f3$var$loadingState = function(addState) {
    $9ba15e4c4f7322f3$var$form.classList[addState === true ? "add" : "remove"]("loading");
    $9ba15e4c4f7322f3$var$submitBtn.disabled = addState;
};
/**
 * Render Success message or Error Message for entire form.
 * @param {string} msgType - accepts two strings: 'success' or 'error'
 */ const $9ba15e4c4f7322f3$var$renderFormMessage = function(msgType) {
    const className = msgType;
    const title = msgType === "success" ? "Thank you" : "Error";
    const msg = msgType === "success" ? "Your message has been delivered." : "Sorry, something went wrong. Please try again later.";
    const icon = msgType === "success" ? "checked" : "error";
    const html = `              
    <div class="message--${className}">
      <p class="title">${title}</p>
      <p class="desc">${msg}</p>
      <svg class="icon">
        <use
          xlink:href="${(0, (/*@__PURE__*/$parcel$interopDefault($e1ce59189af85a62$exports)))}#icon-mail-${icon}"
        ></use>
      </svg>
    </div>`;
    $9ba15e4c4f7322f3$var$form.classList.add("form-message");
    $9ba15e4c4f7322f3$var$form.insertAdjacentHTML("beforeend", html);
};
const $9ba15e4c4f7322f3$var$checkRequiredFields = function() {
    let isError = false;
    $9ba15e4c4f7322f3$var$inputs.forEach((el)=>{
        $9ba15e4c4f7322f3$var$removeInputErrorMsg(el);
        if (!el.checkValidity()) {
            isError = true;
            $9ba15e4c4f7322f3$var$renderInputErrorMsg(el, $9ba15e4c4f7322f3$var$ErrorMsg[el.name]);
        }
    });
    return !isError;
};
const $9ba15e4c4f7322f3$var$makeRequest = async function(data) {
    const res = await fetch($9ba15e4c4f7322f3$var$emailURL, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(data).toString()
    });
    if (res.ok) return res;
    throw new Error(`${res.status}: ${res.statusText}`);
};
const $9ba15e4c4f7322f3$var$submitForm = async function() {
    let isFormValid = $9ba15e4c4f7322f3$var$checkRequiredFields();
    if (isFormValid) {
        const formData = new FormData($9ba15e4c4f7322f3$var$form);
        $9ba15e4c4f7322f3$var$loadingState(true);
        try {
            await $9ba15e4c4f7322f3$var$makeRequest(formData);
            $9ba15e4c4f7322f3$var$renderFormMessage("success");
            $9ba15e4c4f7322f3$var$loadingState(false);
        } catch (error) {
            $9ba15e4c4f7322f3$var$renderFormMessage("error");
        }
    }
};
const $9ba15e4c4f7322f3$export$1e436eb08ebd73ca = function() {
    $9ba15e4c4f7322f3$var$form.addEventListener("submit", (e)=>{
        e.preventDefault();
        $9ba15e4c4f7322f3$var$submitForm();
    });
};


const $e39126ab0493fd36$var$spanYear = document.querySelector('[data-js="footer-year"]');
const $e39126ab0493fd36$export$b3bed366e0f3268b = function() {
    const actualYear = new Date().getFullYear();
    $e39126ab0493fd36$var$spanYear.innerHTML = actualYear;
};


const $331be1cacbd519a2$var$init = function() {
    $603f4f680d794e02$export$abbbf9220a944d5();
    $603f4f680d794e02$export$6ea2a03303ca6765();
    $603f4f680d794e02$export$1f3d3a9da2a0fa96();
    $f743f4b4e300ee64$export$5263a95d66ab56f4();
    $ebe1c8080cae0155$export$a586759acdda70cf();
    $da5314831e868781$export$d5c980a96d3b13bc();
    $9ba15e4c4f7322f3$export$1e436eb08ebd73ca();
    $e39126ab0493fd36$export$b3bed366e0f3268b();
};
$331be1cacbd519a2$var$init();


//# sourceMappingURL=main.min.68af288d.js.map
